export default __webpack_public_path__ + "static/media/e9.74215387.jpg";